<script setup lang="ts">
  import { DividerDirection, DividerVariant } from './Divider.types';
  import { dividerColorClass, dividerDirectionClass } from './Divider.css';
  import { computed } from 'vue';
  import { nToPx, themeVars } from '@tundr/theme';

  export type DividerProps = {
    id?: string;
    testId?: string;
    title?: string;
    variant?: DividerVariant;
    direction?: DividerDirection;
    height?: number;
    width?: number;
    horizontalMargin?: number;
    verticalMargin?: number;
  };

  const props = withDefaults(defineProps<DividerProps>(), {
    variant: DividerVariant.LIGHT,
    direction: DividerDirection.HORIZONTAL,
    height: 1,
  });

  const styles = computed(() => {
    return {
      height: `${props.height}px`,
      width: `${props.width}px`,
      margin:
        props.direction === DividerDirection.VERTICAL
          ? nToPx(0, props.horizontalMargin || themeVars.space.x4)
          : props.direction === DividerDirection.HORIZONTAL
            ? nToPx(props.verticalMargin || themeVars.space.x4)
            : undefined,
    };
  });

  const dividerClasses = computed(() => {
    return `${dividerDirectionClass[props.direction]} ${
      dividerColorClass[props.variant]
    }`;
  });
</script>

<template>
  <div :class="dividerClasses" :style="styles" />
</template>
